import React, { useEffect } from "react";

import "./App.css";
import RenderRouter from "./routes";
import { BrowserRouter as Router } from "react-router-dom";
import { ConfigProvider, Spin, theme as a } from "antd";
import requestService from "api/request";
import { useAppDispatch, useAppSelector } from "store";
import { onLoadingScreen, onSetAppGlobal, onSetUser } from "store/app";
import { useTranslation } from "react-i18next";
function App() {
  const dispatch = useAppDispatch();
  const { user } = useAppSelector((state) => state.app);
  const { i18n } = useTranslation();

const getAppConfigs=async()=>{
  try {
      const res = await requestService.get('/guest/configs')
      if(res && res.data){
        const result = res.data.data.reduce((acc: any, item: any) => {
          const { type, ...rest } = item;

          // Check if the type already exists in the accumulator
          if (!acc[type]) {
            // If type doesn't exist, assign the rest as an object
            acc[type] = rest;
          } else if (Array.isArray(acc[type])) {
            // If type exists and is already an array, push the current item
            acc[type].push(rest);
          } else {
            // If type exists but is not an array, convert it to an array
            acc[type] = [acc[type], rest];
          }

          return acc;
        }, {});
        dispatch(onSetAppGlobal(result))
      }
  } catch (error) {
    console.log(error);
    
  }
}

  const getUser = async () => {
    dispatch(onLoadingScreen(true));
    try {
      const res = await requestService.get("/profile/me");
      if (res && res.data) {
        dispatch(onSetUser(res?.data?.data));
      }
    } catch (error) {
      console.log("====================================");
      console.log(error);
      console.log("====================================");
      localStorage.clear();
    }
    dispatch(onLoadingScreen(false));
  };

  useEffect(() => {
    if (!user && localStorage.getItem("accessToken")) getUser();
  }, [user]);

  useEffect(() => {
    
    if (localStorage.getItem("lang"))
      i18n.changeLanguage(localStorage.getItem("lang") || 'vi' );

    getAppConfigs()
  }, []);

  return (
    <ConfigProvider>
      <div className="__nuxt">
        <div className="__layout">
          <Router>
            <RenderRouter />
          </Router>
        </div>
      </div>
    </ConfigProvider>
  );
}

export default App;
